import { Component, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

// Composants
import { BaseComponent } from 'src/app/@shared/components/abstract/base.component';
import { AccountEntriesExportFormComponent } from '../account-entries-export-form/account-entries-export-form.component';

// Modèles
import { AccountEntryExport } from 'src/app/@shared/models/accounting/account-entry-export.model';

@Component({
    selector: 'app-account-entries-export-dialog',
    imports: [
        AccountEntriesExportFormComponent
    ],
    templateUrl: './account-entries-export-dialog.component.html',
    styleUrl: './account-entries-export-dialog.component.scss'
})
export class AccountEntriesExportDialogComponent extends BaseComponent {
    private _config = inject(DynamicDialogConfig);
    private _ref = inject(DynamicDialogRef);


    /*----------------------------------------------------------------------------------------
     * Gestion de la vue
     ----------------------------------------------------------------------------------------*/



    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/

    private _accountEntryExport!: AccountEntryExport;
    public get accountEntryExport(): AccountEntryExport {
        return this._accountEntryExport;
    }
    public set accountEntryExport(accountEntryExport: AccountEntryExport) {
        this._accountEntryExport = accountEntryExport;
    }

    /*----------------------------------------------------------------------------------------
     * Accesseurs
     ----------------------------------------------------------------------------------------*/



    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    constructor() {
        super();
        this.accountEntryExport = this._config.data.export;
    }

    public onExportSaved(): void {
        this._ref.close();
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes protégées
     ----------------------------------------------------------------------------------------*/



    /*----------------------------------------------------------------------------------------
     * Méthodes privées
     ----------------------------------------------------------------------------------------*/
}
